

















































import { Vue, Component, Watch } from 'vue-property-decorator'
import { Breadcrumb } from '@/interfaces/breadcrumbs'
import { showErrors, showNotification } from '@/utils/snack'
import AppBreadcrumbs from '@/components/AppBreadcrumbs.vue'
import AppRefreshAndExport from '@/components/AppRefreshAndExport.vue'
import AppSearchBtn from '@/components/AppSearchBtn.vue'
import AppSimpleDistrictSelector from '@/components/AppSimpleDistrictSelector.vue'
import { findSchools } from '@/views/SchoolList/gql'
import { SchoolsOrderBy, SchoolModel } from '@/interfaces/school'
import { findDealer } from '@/views/DealerList/gql'
import { updateDealerSchools } from '../gql'
import { SnackType } from '@/interfaces/snack'
import { TypedGqlError } from '@/interfaces/error'

Component.registerHooks(['beforeRouteLeave'])

@Component({
  components: {
    AppBreadcrumbs,
    AppRefreshAndExport,
    AppSearchBtn,
    AppSimpleDistrictSelector
  }
})
export default class EditDealerSchool extends Vue {
  breadcrumbs: Breadcrumb[] = [
    {
      text: '经销商管理'
    },
    {
      text: '经销商',
      to: { name: 'DealerList' }
    }
  ];

  windowSize = {
    w: 0,
    h: 0
  };

  disabledActions = true;
  actionsHeight = 51;

  totalNum = 0;
  loading = false;
  headers = [{ text: '学校', value: 'name' }];

  selectedSchools = [];
  options = {
    sortBy: ['name'],
    sortDesc: [true]
  };

  filter: any = {};
  dealerId = '';
  dealerName = '';
  schools = [];
  allSchools = [];

  @Watch('selectedSchools', { deep: true, immediate: true })
  selectSchools (val: any) {
    if (val.length > 0) {
      this.disabledActions = false
    } else {
      this.disabledActions = true
    }
  }

  get filterSchools () {
    return this.allSchools.filter((item: SchoolModel) => {
      return !this.schools.some((ele: SchoolModel) => ele.id === item.id)
    })
  }

  async mounted () {
    const { id } = this.$route.params
    this.dealerId = id
    await this.getDealerById(Number(this.dealerId))
  }

  filterQuerySubmit () {
    const { area } = this.filter
    this.getSchoolByArea(Number(area.id))
  }

  async getSchoolByArea (id: number) {
    this.loading = true
    try {
      const result = await this.$apollo.query({
        query: findSchools,
        variables: {
          order: {
            by: SchoolsOrderBy.name,
            asc: true
          },
          paging: {
            skip: 0,
            take: 1000
          },
          where: {
            areaId: id
          }
        }
      })
      if (result) {
        this.allSchools = result.data.findSchools.schools
        this.totalNum = this.filterSchools.length
        this.loading = false
      }
    } catch (e) {
      const typedError = e as TypedGqlError
      showErrors(typedError.graphQLErrors)
    }
  }

  async addManageSchoolConfirm () {
    const selectIds = this.selectedSchools.map((item: SchoolModel) => {
      return item.id
    })
    // updateDealerSchools
    const ids = this.schools.map((item: SchoolModel) => {
      return item.id
    })

    try {
      const result = await this.$apollo.mutate({
        mutation: updateDealerSchools,
        variables: {
          dealerId: Number(this.dealerId + ''),
          schoolIds: ids?.concat(selectIds)
        }
      })
      if (result) {
        showNotification({
          msg: '分配成功',
          type: SnackType.Info
        })
        this.disabledActions = true
        this.$router.go(-1)
      }
    } catch (e) {
      const typedError = e as TypedGqlError
      showErrors(typedError.graphQLErrors)
    }
  }

  async getDealerById (dealerId: number) {
    try {
      const result = await this.$apollo.query({
        query: findDealer,
        variables: {
          dealerId
        }
      })
      if (result) {
        const dealer = result.data.findDealer
        this.schools = dealer?.schools
        this.dealerId = dealer?.id + ''
        this.dealerName = dealer?.realname + ''
        this.breadcrumbs = [
          {
            text: '经销商管理'
          },
          {
            text: '经销商',
            to: { name: 'DealerList' }
          },
          {
            text: `${this.dealerName}`,
            to: {
              name: 'DealerDetail',
              params: { id: `${this.dealerId}` }
            }
          },
          { text: '经营学校' }
        ]
      }
    } catch (e) {
      const typedError = e as TypedGqlError
      showErrors(typedError.graphQLErrors)
    }
  }

  onResize () {
    this.windowSize = { w: window.innerWidth, h: window.innerHeight }
    const actionDom = this.$refs.actions as Vue & {
      clientHeight: number;
    }
    this.actionsHeight = actionDom.clientHeight
  }

  async beforeRouteLeave (to: any, from: any, next: any) {
    if (!this.disabledActions) {
      const res = confirm('页面修改尚未保存，是否确定要离开？')
      next(res)
    } else {
      next()
    }
  }
}
